import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ClientITProfile, ComplianceArea} from '../../_models/index';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {LoginHelper,} from '../../helpers';
import {Constants} from "../../helpers/constants";
import {TenantPermissionsService} from "../../_services/tenantPermissions.service";
import {TenantPermissions} from "../../_models/tenantPermissions";
import {Policy} from "../../_models/policy";
import {AlertService, AuthenticationService, ClientProfileService, ComplianceAreaService} from "../../_services";
import {PolicyService} from "../../_services/policy.service";
import {AssessmentService} from "../../_services/assessment.service";
import {TrainingService} from "../../_services/training.service";
import {AuditService} from "../../_services/audit.service";
import {MappingService} from "../../_services/mapping.service";

const now = new Date();

@Component({
    standalone: false,
  selector: 'tenantPermissionsEdit-component',
  templateUrl: 'tenantPermissionsEdit.component.html',
  styleUrls: ['./tenantPermissionsEdit.component.scss'],
})

export class TenantPermissionsEditComponent implements OnInit {
  tenantPermissionsId: number;
  tenantPermissions: TenantPermissions;
  public error = '';
  public complianceAreas: ComplianceArea[];
  public policies: Policy[];


  public profiles: ClientITProfile[];
  public assessments: any[];
  public trainings: any[];
  public audits: any[];
  public mappingTemplates: any[];

  selectedComplianceAreas: ComplianceArea[] = [];
  selectedPolicies: Policy[];
  selectedProfiles: ClientITProfile[];
  selectedAssessments: any[];
  selectedTrainings: any[];
  selectedAudits: any[];
  selectedMappingTemplates: any[];

  constructor(
    public dialogRef: MatDialogRef<TenantPermissionsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public tenantPermissionsService: TenantPermissionsService,
    public complianceAreaService: ComplianceAreaService,
      public policyService: PolicyService,
      public clientProfileService: ClientProfileService,
      public assessmentService: AssessmentService,
      public trainingService: TrainingService,
      public auditService: AuditService,
      public alertService: AlertService,
    public mappingService: MappingService) {

    this.tenantPermissionsId = route.snapshot.params['tenantPermissionsId'];
  }



  ngOnInit() {
    //this.alertService.suppressRootAlert.next(true);

      const tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }


    if (this.data.tenantPermissions.tenantPermissionsId) {
      this.tenantPermissionsService.getTenantPermissions(this.data.tenantPermissions.tenantPermissionsId).subscribe(
        data => {
          this.tenantPermissions = data;
          this.complianceAreaService.getComplianceAreas().subscribe(d => {
            this.complianceAreas = d;
              const items = (data.defaultComplianceAreas || '').split(',');
              this.selectedComplianceAreas = d.filter(m => items.indexOf("" + m.complianceAreaId) >= 0);
          });
          this.policyService.getAllPolicys().subscribe(d => {
            this.policies = d;
              const items = (data.defaultPolicies || '').split(',');
              this.selectedPolicies = d.filter(m => items.indexOf("" + m.id) >= 0);
          });
          this.clientProfileService.getClientProfiles(Constants.RiskSpongeMaster).subscribe(d => {
            this.profiles = d;
              const items = (data.defaultProfiles || '').split(',');
              this.selectedProfiles = d.filter(m => items.indexOf("" + m.clientITProfileId) >= 0);
          });
          this.assessmentService.getAllAssessments().subscribe(d => {
            this.assessments = d;
              const items = (data.defaultAssessments || '').split(',');
              this.selectedAssessments = d.filter(m => items.indexOf("" + m.id) >= 0);
          });
          this.trainingService.getAllTrainings().subscribe(d => {
            this.trainings = d;
              const items = (data.defaultTrainings || '').split(',');
              this.selectedTrainings = d.filter(m => items.indexOf("" + m.id) >= 0);
          });
          this.auditService.getAllAudits().subscribe(d => {
            this.audits = d;
              const items = (data.defaultAudits || '').split(',');
              this.selectedAudits = d.filter(m => items.indexOf("" + m.auditId) >= 0);
          });
          this.mappingService.getMappingTemplates().subscribe(d => {
            this.mappingTemplates = d;
              const items = (data.defaultMappingTemplates || '').split(',');
              this.selectedMappingTemplates = d.filter(m => items.indexOf("" + m.mappingTemplateId) >= 0);
          });
        });
    } else {
      this.tenantPermissions = <any>{tenantPermissionsId: null};
      this.complianceAreaService.getComplianceAreas().subscribe(d => {
        this.complianceAreas = d;
        this.selectedComplianceAreas = [];
      });
      this.policyService.getAllPolicys().subscribe(d => {
        this.policies = d;
        this.selectedPolicies = [];
      });
      this.clientProfileService.getClientProfiles(Constants.RiskSpongeMaster).subscribe(d => {
        this.profiles = d;
        this.selectedProfiles = [];
      });
      this.assessmentService.getAllAssessments().subscribe(d => {
        this.assessments = d;
        this.selectedAssessments = [];
      });
      this.trainingService.getAllTrainings().subscribe(d => {
        this.trainings = d;
        this.selectedTrainings = [];
      });
      this.auditService.getAllAudits().subscribe(d => {
        this.audits = d;
        this.selectedAudits = [];
      });
      this.mappingService.getMappingTemplates().subscribe(d => {
        this.mappingTemplates = d;
        this.selectedMappingTemplates = [];
      });
    }
  }



  onSave() {
    this.tenantPermissions.defaultComplianceAreas = (this.selectedComplianceAreas || []).map(c => c.complianceAreaId).join(',');
    this.tenantPermissions.defaultPolicies = (this.selectedPolicies || []).map(c => c.id).join(',');
    this.tenantPermissions.defaultProfiles = (this.selectedProfiles || []).map(c => c.clientITProfileId).join(',');
    this.tenantPermissions.defaultAssessments = (this.selectedAssessments || []).map(c => c.id).join(',');
    this.tenantPermissions.defaultTrainings = (this.selectedTrainings || []).map(c => c.id).join(',');
    this.tenantPermissions.defaultAudits = (this.selectedAudits || []).map(c => c.auditId).join(',');
    this.tenantPermissions.defaultMappingTemplates = (this.selectedMappingTemplates || []).map(c => c.mappingTemplateId).join(',');

    if (this.tenantPermissions.tenantPermissionsId) {
      this.tenantPermissionsService.updateTenantPermissions(this.tenantPermissions)
        .subscribe(
          tenantPermissions => {
            this.alertService.success('Edition was updated.', true);
            this.onClose();
          },
          error => {
            this.alertService.error(error._body || error);
          });
    } else {
      this.tenantPermissionsService.addTenantPermissions(this.tenantPermissions)
        .subscribe(
          user => {
            this.alertService.success('The user profile was created.', true);
            this.onClose();
          },
          error => {
            this.alertService.error(error._body || error);
          });
    }
  }


  onClose(): void {
    this.dialogRef.close();
  }
}
